import { ActionCards } from 'components/actions/ActionCards'
import { Block } from 'components/Block'
import { Button } from 'components/button/Button'
import { useDashboardSideModal } from 'components/content/dashboardSideModal/utils'
import { useCreateDirectiveLogic } from 'components/directive/utils/directiveUtils'
import { useDirectiveActionsWithInfoModal } from 'components/directive/utils/useDirectiveActionsWithInfoModal'
import { useEstatePlanningTabs } from 'components/directive/utils/useEstatePlanningTabs'
import { HeaderDashboard } from 'components/header/headerDashboard/HeaderDashboard'
import { Icon } from 'components/icon'
import { PageTitle } from 'components/PageTitle'
import { ProfileContent, ProfileWrapper } from 'components/profile/profileContent/ProfileContent'
import { ProfileSidebar } from 'components/profile/profileSidebar/ProfileSidebar'
import { SideLayout } from 'components/sideLayout/SideLayout'
import { Spacer } from 'components/spacer/Spacer'
import { Stack } from 'components/Stack'
import { RouterTabs } from 'components/tabs/RouterTabs'
import { Text } from 'components/Typography'
import { WizardHero } from 'components/wizard/wizardHero/WizardHero'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { getContentfulVideoIds } from 'utils/contentful/getPageImages'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation('estate_planning_lp')
  const { cta, create, isCreating } = useCreateDirectiveLogic('WILL')

  const [sideModal, openSideModal] = useDashboardSideModal('ESTATE_PLANNING')

  const { tabs, defaultTabKey } = useEstatePlanningTabs()

  const [actions, directiveInfoModal] = useDirectiveActionsWithInfoModal()

  return (
    <SideLayout left={<ProfileSidebar />} header={<HeaderDashboard />}>
      {directiveInfoModal}
      {sideModal}

      <PageTitle title={t('estate_planning_lp.inside.meta_title')} />

      <Block>
        <ProfileWrapper>
          <ProfileContent hideBack>
            <WizardHero
              caption={t('estate_planning_lp.inside.hero_caption')}
              title={t('estate_planning_lp.inside.hero_title')}
              pictureKey={'illustrations/family'}
            >
              <Stack space={'1rem'}>
                <Text variant={'body'}>{t('estate_planning_lp.inside.hero_text')}</Text>
                <Stack space="1rem" orientation={['vertical', 'vertical', 'horizontal']}>
                  <Button tone="accent" type="button" onClick={create} loading={isCreating}>
                    {cta}
                  </Button>
                  <Button
                    tone="accent"
                    type="button"
                    variant="secondary"
                    leftIcon={<Icon name="LightBulb" />}
                    onClick={() => {
                      openSideModal()
                    }}
                  >
                    {t('estate_planning_lp.inside.hero_button')}
                  </Button>
                </Stack>
              </Stack>
            </WizardHero>

            <Spacer size={2} />

            <Stack space="4rem">
              <Block>
                <ActionCards
                  variant="text-button"
                  actions={actions}
                  buttonCss={{ alignSelf: 'flex-start' }}
                  scrollability="always"
                  scrollerCss={{ paddingLeft: 0 }}
                  css={{ gridArea: 'left / left / right / right' }}
                />
              </Block>

              <RouterTabs
                tabs={tabs}
                defaultTabKey={defaultTabKey}
                tabContentCss={{ paddingTop: '1.5rem' }}
              />
            </Stack>
          </ProfileContent>
        </ProfileWrapper>
      </Block>
    </SideLayout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: {
      ...(await getIntlProps(
        ctx,
        ['dashboard', 'directive_lp_common', 'estate_planning_lp', 'trusted_contact', 'device'],
        true
      )),
      ...(await getContentfulVideoIds()),
    },
  }
}
